(async () => {
  if (!customElements.get('product-card-swiper')) {
    const {
      default: Swiper,
      Navigation,
      A11y,
      Pagination,
      Scrollbar,
      Autoplay,
      Thumbs,
    } = await import('swiper');

    Swiper.use([Navigation, A11y, Pagination, Scrollbar, Autoplay, Thumbs]);

    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        // elements
        this.productCard = this.closest('[data-product-card]');
        this.featuresPopup = document.querySelector('[data-features-popup]');

        // methods
        this.createThumbSlider();
        this.createSwiper();
        this.handleSwiperButtons();

        // event listeners
        this.productCard.querySelectorAll('[data-popup-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', () => this.popup(trigger));
        });

        window.addEventListener('resize', () => {
          this.handleSwiperButtons();
        });
      }

      createThumbSlider() {
        // Check if Swiper exists
        if (!Swiper) return false;

        // Get Thumbnails slider element & Set swiper options
        this.swiperThumbs = this.querySelector('[data-product-card-thumbnails-slider]');
        this.swiperThumbsOptions = {
          spaceBetween: 8,
          direction: 'horizontal',
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          navigation: {
            nextEl: '.swiper-button-thumbnails-next--product-card',
            prevEl: '.swiper-button-thumbnails-prev--product-card',
          },
        };

        this.swiperThumbsInstance = new Swiper(this.swiperThumbs, this.swiperThumbsOptions);

        // Rebuild Swiper in design mode after delay
        if (Shopify.designMode && this.swiperThumbsInstance) {
          window.addEventListener('shopify:section:load', () => {
            setTimeout(() => {
              this.swiperThumbsInstance.update();
            }, 300);
          });
        }
      }

      createSwiper() {
        // Check if Swiper exists
        if (!Swiper) return false;

        this.swiperElement = this.querySelector('[data-product-card-swiper]');

        let thumbOptions;
        if (this.swiperThumbsInstance) {
          thumbOptions = {
            thumbs: {
              swiper: this.swiperThumbsInstance,
              slideThumbActiveClass: 'swiper-slide-thumb-active border-primary',
            },
          };
        }

        this.swiperOptions = {
          watchOverflow: true,
          preventClicks: true,
          loop: false,
          autoplay: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          slidesPerView: 1,
          direction: 'horizontal',
          ...thumbOptions,
          breakpoints: {
            1024: { allowTouchMove: false },
          },
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = parseJson(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

      handleSwiperButtons() {
        let windowWidth = window.innerWidth;
        if (windowWidth < 1024) {
          this.querySelectorAll('button').forEach((button) => button.classList.remove('hidden'));
        } else if (this.swiperInstance) {
          this.querySelectorAll('button').forEach((button) => button.classList.add('hidden'));
        }
      }

      popup(trigger) {
        const titleHandle = trigger.dataset.featureHandle;
        const feature = window.productFeatures.find((item) => item.handle === titleHandle);

        if (!feature) return;

        this.featuresPopup.querySelector('[data-popup-title]').textContent = feature.title;
        this.featuresPopup.querySelector('[data-popup-content]').innerHTML = feature.description;

        if (feature.button_label != '' && feature.button_link != '') {
          this.featuresPopup.querySelector('[data-popup-button]').classList.remove('hidden');
          this.featuresPopup.querySelector('[data-popup-button]').textContent =
            feature.button_label;
          this.featuresPopup.querySelector('[data-popup-button]').attributes.href.value =
            feature.button_link;
        } else {
          this.featuresPopup.querySelector('[data-popup-button]').classList.add('hidden');
        }

        this.featuresPopup.open();
      }
    }

    window.ProductCard = ProductCard;

    customElements.define('product-card-swiper', ProductCard);
  }
})();
